export function highlightJSON(obj: any, indent: number = 0): string {
  const pad = '  '.repeat(indent)
  const padNext = '  '.repeat(indent + 1)
  if (obj === null) return '<span class="b">null</span>'
  if (typeof obj === 'boolean') return '<span class="b">' + obj + '</span>'
  if (typeof obj === 'number') return '<span class="n">' + obj + '</span>'
  if (typeof obj === 'string')
    return '<span class="s">"' + obj.replace(/"/g, '\\"') + '"</span>'
  if (Array.isArray(obj)) {
    if (obj.length === 0) return '<span class="p">[]</span>'
    const items = obj.map((v) => padNext + highlightJSON(v, indent + 1))
    return (
      '<span class="p">[</span>\n' +
      items.join('<span class="p">,</span>\n') +
      '\n' +
      pad +
      '<span class="p">]</span>'
    )
  }
  if (typeof obj === 'object') {
    const keys = Object.keys(obj)
    if (keys.length === 0) return '<span class="p">{}</span>'
    const lines = keys.map((k) => {
      return (
        padNext +
        '<span class="k">"' +
        k +
        '"</span><span class="p">:</span> ' +
        highlightJSON(obj[k], indent + 1)
      )
    })
    return (
      '<span class="p">{</span>\n' +
      lines.join('<span class="p">,</span>\n') +
      '\n' +
      pad +
      '<span class="p">}</span>'
    )
  }
  return String(obj)
}
